import { forwardRef } from "react";
import type { HTMLAttributes } from "react";
import "./ProgressBar.css";

export interface ProgressBarProps extends HTMLAttributes<HTMLDivElement> {
  /** 0–100. Omit to render the indeterminate animation. */
  value?: number;
  /** Defaults to 100. */
  max?: number;
  /** Accessible label for screen readers. */
  label?: string;
}

const cx = (...classes: Array<string | false | undefined>) => classes.filter(Boolean).join(" ");

const clamp = (n: number, min: number, max: number) => Math.min(Math.max(n, min), max);

export const ProgressBar = forwardRef<HTMLDivElement, ProgressBarProps>(function ProgressBar(
  { value, max = 100, label, className, ...rest },
  ref,
) {
  const isIndeterminate = value == null;
  const pct = isIndeterminate ? undefined : (clamp(value!, 0, max) / max) * 100;
  return (
    <div
      ref={ref}
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={max}
      aria-valuenow={isIndeterminate ? undefined : value}
      className={cx("go4-progress", className)}
      {...rest}
    >
      <div
        className={cx("go4-progress__fill", isIndeterminate && "go4-progress__fill--indeterminate")}
        style={isIndeterminate ? undefined : { width: `${pct}%` }}
      />
    </div>
  );
});
